import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";
const lightenRate = 45;

export default makeStyles((theme) => ({
  buttoncountcontainer: {
    marginTop: 15,
    marginBottom: 15
  },
  pickercontainer: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    height: 60,
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 20px",
    marginBottom: 20
  },
  label: {
    fontWeight: "500",
    fontSize: "16px"
  },
  previewImage: {
    // marginTop: "10px",
    width: "140px",
    height: "140px",
    borderRadius: "50%",
    border: "2px solid #FFFFFF",
    objectFit: "cover"
  },
  picker: {
    opacity: 0,
    width: "100%",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: "100%",
    cursor: "pointer",
    position: "absolute"
  },
  subjectclicked: {
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.1).toRgbString(),
    textAlign: "center",
    width: "100%",
    padding: "7px",
    borderRadius: "6px",
    marginBottom: "10px",
    "& h4": {
      marginBlock: "5px"
    }
  },
  uploadbutton: {
    // backgroundColor: theme.palette.primary.main,
    width: 86,
    height: 39,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    color: "white",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  uploadflex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8
  },
  uploadicon: {
    fontSize: 16,
    color: "#101928"
  },
  uploadcont: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  uploadtitle: {
    fontSize: 16,
    color: "#101928",
    marginBottom: 3,
    marginTop: 0
  },
  uploadsubtitle: {
    color: "#98A2B3",
    fontsize: 16,
    marginBlock: 0
  },
  modalFooterBtn: {
    display: "flex",
    width: "100%",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 500px)": {
      flexWrap: "wrap"
    }
  },
  mail: {
    paddingLeft: "0%",
    gap: "2px",
    color: "#0065FF",
    fontWeight: "500",
    lineHeight: "17.4px",
    cursor: "pointer",
    "& p": {
      marginBlock: "5px 5px",
      fontSize: "14px"
    }
    // letterSpacing: "-5px"
  },
  detailstext: {
    textAlign: "left"
  },
  pagedivider: {
    marginTop: 40,
    marginBottom: 40,
    color: "#DFE2E7"
  },
  title: {
    color: "#98A2B3",
    fontSize: 14,
    marginBottom: 3
  },
  subtitle: {
    color: "#40444B",
    fontSize: 14,
    fontWeight: 500
  },
  calendar: {
    border: "1px solid #E4E7EC",
    padding: "16px",
    borderRadius: "16px",
    marginTop: "15px"
  },
  terminfo: {
    maxWidth: "300px",
    marginLeft: "auto",
    marginBottom: "20px",
    padding: "5px",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "5px",
    "& p": {
      fontWeight: "500",
      marginBlock: "0px",
      fontSize: "14px",
      color: theme.palette.primary.main
    }
  },
  tableContainer: {
    marginTop: "24px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    height: "calc(100vh - 400px)",
    position: "relative"
  },
  subjectHeader: {
    fontWeight: "bold",
    backgroundColor: "#f5f5f5",
    position: "sticky",
    borderRight: "1px solid #e0e0e0",
    textAlign: "left",
    minWidth: 200,
    top: 0,
    zIndex: 5,
    width: "25%",
    padding: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      minWidth: 150,
      padding: theme.spacing(1),
      fontSize: "0.75rem"
    }
  },
  subjectCell: {
    textAlign: "left",
    minWidth: 200,
    width: "25%",
    padding: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      minWidth: 150,
      padding: theme.spacing(1),
      fontSize: "0.75rem"
    }
  },
  headerCell: {
    fontWeight: "400",
    textAlign: "center !important",
    fontSize: "1rem",
    backgroundColor: "#F9FAFB",
    color: "#344054",
    position: "sticky",
    top: 0,
    zIndex: 5,
    whitespace: "noWrap"
  },
  subHeaderCell: {
    fontWeight: "400",
    textAlign: "center",
    backgroundColor: "#F9FAFB",
    color: "#344054",
    position: "sticky",
    top: 48,
    zIndex: 4,
    width: "fitContent"
  },
  firstColumn: {
    position: "sticky",
    left: 0,
    zIndex: 7,
    backgroundColor: "#F9FAFB"
  },
  secondRowCol: {
    position: "sticky",
    left: 0,
    zIndex: 6,
    backgroundColor: "#F9FAFB"
  },
  bodyCell: {
    textAlign: "center",
    padding: "8px",
    // BorderRight: "1px solid #E4E7EC",
    color: "#344054"
  },
  separator: {
    borderRight: "1px solid #E4E7EC"
  },
  bodyRowOdd: {
    backgroundColor: "#F7F8FA"
  },
  headinfo: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
    alignItems: "center"
  },
  searchcont: {
    maxWidth: "100%"
  },
  noresult: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center"
  },
  resultbtn: {
    display: "flex",
    justifyContent: "left",
    marginBottom: "10px"
  },
  cardcount: {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexGrow: 1,
    minHeight: 96,
    // backgroundColor: "white",
    padding: "16px 24px",
    border: "1px solid transparent"
  },
  left: {
    textAlign: "left"
  },
  cardtitle: {
    fontSize: 16,
    fontWeight: 400,
    color: "#475367",
    letterSpacing: -0.5,
    marginBottom: 0,
    marginTop: 0
  },
  count: {
    fontSize: 24,
    fontWeight: 500,
    marginBottom: 0,
    marginTop: 0,
    color: "#344054"
  },
  icon: {
    border: "1px solid #E4E7EC",
    width: 40,
    height: 40,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center"
  },
  overallcont: {
    minWidth: 242,
    border: "1px solid #E4E7EC",
    borderRadius: 8,
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: tinycolor(theme.palette.primary.main)
        .lighten(lightenRate)
        .toHexString(),
      border: `1px solid ${theme.palette.primary.main}`
    },
    "& hr": {
      marginBlock: "0px",
      border: "1px solid #E4E7EC"
    }
  },
  bottomcont: {
    display: "flex",
    padding: "0px 24px",
    justifyContent: "space-between"
  },
  extra: {
    marginBottom: "1.5rem",
    marginTop: "1rem"
  },
  extrahead: {
    margin: 0,
    padding: "0.65rem 1rem",
    fontSize: "0.75rem",
    textAlign: "left",
    backgroundColor: "#f5f5f5",
    width: "100%"

  },
  logoContent: {
    height: "50px",
    filter: "brightness(0) saturate(100%) invert(1)"
  },
  reportheader: {
    // backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.7).toRgbString(),
    backgroundColor: theme.palette.primary.main,
    padding: "36px",
    color: "#FFFFFF",
    textAlign: "center",
    "& h1": {
      fontWeight: 700,
      fontSize: "20px",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      color: "#FFFFFF",
      margin: "0px"
    }
  },
  imageWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
  },
  profiledata: {
    textAlign: "left",
    "& h6": {
      fontWeight: 400,
      fontSize: "12px",
      marginBlock: "0px",
      color: "#6D6D6D"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      marginBlock: "0px",
      color: "#344054"
    }
  },
  profile: {
    height: "80px"
    // border: "1px solid #FFFFFF",
    // "@media (max-width: 600px)": {
    //   marginTop: "10px"
    // }
  },
  termdata: {
    marginBlock: "20px",
    width: "100%",
    padding: "8px",
    backgroundColor: theme.palette.primary.main,
    "& h1": {
      fontWeight: 700,
      fontSize: "16px",
      marginBlock: "0px",
      textAlign: "center",
      color: "#FFFFFF"
    }
  },
  container: {
    position: "relative",
    backgroundColor: "#f9fafc",
    borderRadius: 12,
    padding: 10,
    height: "100%",
    border: "1px solid #e0e0e0"
  },
  templatetitle: {
    fontWeight: 600,
    marginBottom: "1.5rem",
    fontSize: "1.25rem",
    color: "#111"
  },
  card: {
    borderRadius: 12,
    overflow: "hidden",
    border: "1px solid transparent",
    transition: "all 0.3s ease",
    cursor: "pointer",
    "&:hover": {
      borderColor: "#1976d2"
    }
  },
  activeCard: {
    borderColor: "#1976d2",
    boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.3)"
  },
  mycards: {
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.1).toRgbString(),
    padding: "10px",
    marginRight: "10px",
    borderRadius: "8px"
  },
  lockedCard: {
    filter: "blur(2px)",
    cursor: "not-allowed"
  },
  image: {
    width: "100%",
    height: "inherit",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem",
    "& svg": {
      width: "100%",
      height: "inherit",
      maxHeight: 260,
      objectFit: "contain"
    }
  },
  modalimage: {
    width: "100%",
    height: "20rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem",
    "& svg": {
      width: "100%",
      height: "7rem",
      maxHeight: 260,
      objectFit: "contain"
    }
  },
  templateName: {
    textAlign: "center",
    padding: "0.45rem 0",
    fontWeight: 500,
    fontSize: "0.95rem",
    color: "#333",
    margin: 0
  },
  locknote: {
    width: "97%",
    position: "absolute",
    bottom: "10px",
    right: "10px",
    left: "10px",
    display: "flex",
    alignItems: "flex-start",
    gap: "6px",
    justifyContent: "flex-start",
    textAlign: "left",
    marginTop: "1.5rem",
    background: "#fff",
    padding: "0.75rem 1rem",
    borderRadius: 8,
    border: "1px dashed #ccc",
    fontSize: "0.85rem",
    color: "#555",
    "& p": {
      marginBlock: "0px"
    }
  },
  previewContent: {
    textAlign: "center"
  },
  previewTempImage: {
    maxWidth: "100%",
    maxHeight: "400px",
    objectFit: "contain",
    marginBottom: theme.spacing(2)
  },
  previewInfo: {
    textAlign: "center"
  },
  titlediv: {
    width: "100%",
    height: "46px",
    boxSizing: "border-box",
    paddingLeft: "10px",
    paddingRight: "10px",
    border: "1px solid hsl(0, 0%, 80%)",
    marginTop: "4px",
    borderRadius: "6px",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#667185",
    "& input": {
      border: "none",
      outline: "none",
      fontSize: "14px",
      color: "#667185",
      background: "transparent",
      width: "100%"
    } },
  secondreportmain: {
    position: "relative"
  },
  secondreportheader: {
    // backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.7).toRgbString(),
    // backgroundColor: "#E0E0E0",
    padding: "36px",
    color: theme.palette.primary.main,
    textAlign: "center",
    "& h1": {
      fontWeight: 700,
      fontSize: "20px",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      margin: "0px"
    }
  },
  secondlogoContent: {
    height: "50px"
  },
  stdninfo: {
    paddingInline: "16px"
  },
  topBorderWrapper: {
    position: "relative",
    width: "100%",
    height: "40px",
    backgroundColor: "#fff",
    overflow: "hidden"
  },
  topBorder: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "40px",
    width: "100%",
    backgroundColor: theme.palette.primary.main,
    clipPath: "polygon(0 0, 94% 0, 93% 40%, 0 40%)"
  },
  topBorderInner: {
    position: "absolute",
    top: 10,
    right: 0,
    height: "10px",
    width: "100%",
    backgroundColor: "#fff",
    clipPath: "polygon(6% 0, 100% 0, 100% 100%, 7% 100%)"
  },
  secondtermdata: {
    marginBlock: "20px",
    width: "100%",
    padding: "16px 8px 8px 8px",
    // backgroundColor: theme.palette.primary.main,
    "& h1": {
      fontWeight: 700,
      fontSize: "16px",
      marginBlock: "0px",
      textAlign: "center",
      color: theme.palette.primary.main
    }
  },
  tembottomimage: {
    width: "100%",
    fill: theme.palette.primary.main
  },
  borderleftright: {
    borderLeft: `2px solid ${theme.palette.primary.main} `,
    borderRight: `2px solid ${theme.palette.primary.main} `
  },
  linescontainer: {
    display: "flex",
    flexDirection: "column",

    gap: "6px",
    width: "100%",
    // maxWidth: "400px",
    alignItems: "center"
  },
  line1: {
    height: "2.97px",
    width: "60%",
    backgroundColor: theme.palette.primary.main
  },
  line2: {
    height: "2.97px",
    width: "65%",
    backgroundColor: theme.palette.primary.main
  },
  line3: {
    height: "2.97px",
    width: "60%",
    backgroundColor: theme.palette.primary.main
  },
  add: {
    cursor: "pointer",
    gap: "2px",
    color: theme.palette.primary.main,
    fontWeight: "500",
    lineHeight: "17.4px"
  },
  // TermBroadsheet
  acontainer: {
    minHeight: "100vh"
  },
  selectionContainer: {
    marginBottom: "32px"
  },
  filters: {
    display: "flex",
    gap: "16px",
    marginBottom: "24px",
    flexWrap: "wrap",
    "& > div": {
      minWidth: "200px"
    }
  },
  classesContainer: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    marginBottom: "24px"
  },
  searchContainer: {
    maxWidth: "300px",
    marginBottom: "8px"
  },
  classesHeader: {
    fontSize: "18px",
    fontWeight: "600",
    textAlign: "left",
    color: "#333",
    marginBottom: "16px"
  },
  classesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: "16px"
  },
  tableHeaderLeft: {
    textAlign: "left",
    marginBottom: "8px"
  },
  backButton: {
    display: "flex",
    justifyContent: "left",
    padding: "8px 0px",
    borderRadius: "8px",
    color: "#666",
    cursor: "pointer",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: "500",
    backgroundColor: "#fff",
    "& .MuiButton-startIcon": {
      marginRight: "8px"
    }
  },
  classBox: {
    backgroundColor: "#fff",
    border: "2px solid #e0e0e0",
    borderRadius: "8px",
    padding: "20px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(74, 144, 226, 0.15)"
    }
  },
  classBoxActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: "#f0f7ff",
    "& $className": {
      color: "#4a90e2"
    }
  },
  classBoxContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center"
  },
  className: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "8px"
  },
  classType: {
    fontSize: "14px",
    color: "#666",
    backgroundColor: "#f5f5f5",
    padding: "4px 12px",
    borderRadius: "4px"
  },
  resultsContainer: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
  },
  resultsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    flexWrap: "wrap",
    gap: "16px"
  },
  resultsTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#333",
    margin: 0
  },
  tableWrapper: {
    overflowX: "auto",
    "& table": {
      minWidth: "800px"
    }
  },
  actionBtn: {
    color: "#4a90e2",
    "&:hover": {
      backgroundColor: "rgba(74, 144, 226, 0.1)"
    }
  },
  studentModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
    }
  },
  studentModalContent: {
    position: "absolute",
    right: 0,
    top: 0,
    height: "100vh",
    width: "65%",
    backgroundColor: "#fff",
    boxShadow: "-4px 0 16px rgba(0, 0, 0, 0.1)",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)"
  },
  studentModalHeader: {
    padding: "24px",
    borderBottom: "1px solid #eee",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  studentModalTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#333",
    margin: 0
  },
  closeButton: {
    color: "#666",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)"
    }
  },
  studentModalBody: {
    padding: "24px",
    flex: 1,
    overflowY: "auto"
  },
  noData: {
    textAlign: "center",
    padding: "48px 24px",
    color: "#666",
    fontSize: "16px"
  },
  notfound: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
    "& img": {
      maxWidth: "300px"
    }
  },
  promotionheader: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "8px",
    padding: "0px 8px 10px 8px",
    maxWidth: "550px",
    marginBottom: "24px"
  },
  modeContainer: {
    display: "flex",
    alignItems: "center",
    // flexDirection: "column",
    gap: "10px"
  },
  modeContainers: {
    display: "flex",
    alignItems: "center",
    marginTop: "20px",
    // flexDirection: "column",
    gap: "10px"
  },

  modeLabel: {
    fontSize: "14px",
    fontWeight: "600",
    margin: 0
  },

  modeOptions: {
    display: "flex",
    gap: "16px",
    alignItems: "center"
  },

  modeOption: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "13px",
    cursor: "pointer"
  },
  wrapper: {
    width: "100%",
    textAlign: "left",
    "& h4": {
      marginBlock: "0px",
      color: "#40444B"
    },
    "& p": {
      marginBlock: "0px"
    }
  },
  headerItems: {
    border: "1px solid #DFE2E7",
    borderRadius: "12px",
    padding: "10px 20px 15px 20px"
  },
  saveAllSection: {
    marginBlock: "20px"
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24
  },

  globalSettings: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 20,
    padding: 20,
    border: "1px solid #E6E8EC",
    borderRadius: 12,
    background: "#FFFFFF",
    marginBottom: 32
  },

  globalCard: {
    display: "flex",
    flexDirection: "column",
    gap: 10
  },

  toggleHeader: {
    display: "flex",
    // justifyContent: "space-between",
    alignItems: "center"
  },

  passmarkInputGroup: {
    display: "flex",
    alignItems: "center",
    gap: 12,

    "& input": {
      width: 70,
      height: 40,
      borderRadius: 8,
      textAlign: "center",
      border: "1px solid #D0D5DD",
      padding: "0 10px",
      fontSize: 14
    }
  },

  classGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 20
  },

  classCard: {
    border: "1px solid #E6E8EC",
    borderRadius: 12,
    padding: 20,
    background: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    gap: 14
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 14
  },

  value: {
    fontWeight: 500,
    color: "#101828"
  },

  checkboxRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 14,

    "& input": {
      width: 16,
      height: 16
    }
  },

  /* ===== PASS MARK ROW (AS REQUESTED) ===== */
  passmark: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 6,

    "& span": {
      fontSize: 14,
      color: "#667085"
    },

    "& input": {
      width: 70,
      height: 38,
      borderRadius: 8,
      border: "1px solid #D0D5DD",
      padding: "0 10px",
      fontSize: 14,

      "&:disabled": {
        background: "#F2F4F7",
        cursor: "not-allowed"
      }
    }
  },
  // Responsive styles
  "@media (max-width: 768px)": {
    container: {
      padding: "16px"
    },
    filters: {
      flexDirection: "column",
      "& > div": {
        minWidth: "100%"
      }
    },
    classesGrid: {
      gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))"
    },
    resultsHeader: {
      flexDirection: "column",
      alignItems: "stretch"
    },
    searchContainer: {
      minWidth: "100%"
    },
    studentModalContent: {
      width: "100%"
    }
  }
}));
